import { render, staticRenderFns } from "./Submitting.vue?vue&type=template&id=17aee738&"
import script from "./Submitting.vue?vue&type=script&lang=js&"
export * from "./Submitting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports